import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  label: PropTypes.string.isRequired,
  cumulativeViewMode: PropTypes.bool.isRequired,
  legendItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      stroke: PropTypes.string.isRequired
    })
  ).isRequired
};

const PerformanceChartEmptyState = ({ label, cumulativeViewMode, legendItems }) => {
  const statsLabel = label.toLowerCase();
  const frequencyLabel = cumulativeViewMode ? "total" : "daily";

  return (
    <div className="performance-chart-empty-state">
      <span className="performance-chart-empty-state__badge">No data yet</span>
      <div className="performance-chart-empty-state__graphic">
        <svg
          className="performance-chart-empty-state__graphic-svg"
          viewBox="0 0 600 240"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            className="performance-chart-empty-state__graphic-fill"
            d="M0,200 L600,40 L600,240 L0,240 Z"
          />
          <path className="performance-chart-empty-state__graphic-line" d="M0,200 L600,40" />
        </svg>
        <div className="performance-chart-empty-state__message">
          <p className="performance-chart-empty-state__message-title">
            Your {statsLabel} will chart here
          </p>
          <p className="performance-chart-empty-state__message-body">
            Once your ad starts serving, this graph fills in with your {frequencyLabel} {statsLabel}
            . Data usually appears within 24 hours.
          </p>
        </div>
      </div>
      <div className="performance-chart-empty-state__legend">
        {legendItems.map(item => (
          <span className="performance-chart-empty-state__legend-item" key={item.key}>
            <span
              className="performance-chart-empty-state__legend-swatch"
              style={{ backgroundColor: item.stroke }}
            />
            {item.name}
          </span>
        ))}
      </div>
    </div>
  );
};

PerformanceChartEmptyState.propTypes = propTypes;

export default PerformanceChartEmptyState;
